import apiClient from '@/services/axios'

export async function get(venueId) {
  //console.log("Called venue visit sessions for", venueId);
  var response = await apiClient.get(`/VenueVisitSessions/${venueId}`)
  //var response = await apiClient.get(`/VenueVisitSessions/bc1df643-e39b-4a03-b895-d47e888c914c`)
  if (response) {
    return response.data
  }

  throw new Error('Unable to get venue visits')
}
